module.exports = __webpack_public_path__ + "img/Pista_01.7bab3d89.png";